/*
* Interaction behavior for Sample Graph
*
* Features:
*   - Highlight point on mouse over
*   - Drag-select series of data
*   - Click-select individual point
*
* Triggers these events on graph object:
*   - pointselected(i)
*   - segmentselected(dataSlice)
*   - mousedown(e)
*   - mouseover(e)
*   - mousemove(canvasX, canvasY, e)
*   - mouseout(e)
*   - verticalmouseout(e)
*
* Not required if user interaction is not desired.
*/

(function (SG, window) {
  SG.registerModule('interaction');
  SG.bind('initialize:after', function(graph) { 
    _.bindAll(graph, 'highlightPointUnderMouse', 'onMouseOut', 'beginDragSelect', 'switchToTimeXAxis', 'switchToDistanceXAxis', 'setDragBehaviorToZoomIn');
    graph.$body = $('body');
    // this is a fancy global page thing that helps the graph trigger mouseover/mousemove/mouseout 
    graph.setupMouseMove();
    // mousedown can originate from the canvas element, or the floating hover line. 
    // the hover line gets created/removed periodically, so here's how we consolidate those mousedown events
    graph.$canvas.mousedown(function(e) { if(e.button === 0) graph.trigger('mousedown', e); });
    graph.bindTo(graph, 'hoverEl:created', function() {
      graph.$hoverElHorizontal.mousedown(function(e) { if(e.button === 0) graph.trigger('mousedown', e); });
      graph.$hoverElVertical.mousedown(function(e) { if(e.button === 0) graph.trigger('mousedown', e); });
    });
    // bind our default behavior
    graph.bindMouseInteractions();
    graph.bindTo(graph, 'zoom:in', graph.defaultMouseOutCleanup);
    graph.bindTo(graph, 'zoom:out', graph.defaultMouseOutCleanup);
    graph.bindTo(graph, 'render:after', graph.redrawOverlays);
    graph.bindTo(graph, 'render:after', graph.bindEvents);
    // when beginDragSelect is ran, it attaches a mouseup handler to
    // <body>. jQuery doesn't let us control context, so let's permanently
    // bind it to the graph context.
    graph.completeDragSelect = _.bind(graph.completeDragSelect, graph);
    // set default drag action
    graph.setDragBehaviorToZoomIn();
  });

  SG.bind('unload_bindings:before', function(graph) {
    // unload our click handlers
    $('.sample-graph-render-text').off('click', '.sg-on-drag-zoom-in', graph.setDragBehaviorToZoomIn);
    $('.sample-graph-render-text').off('click', '.sample-graph-x-axis-use-time', graph.switchToTimeXAxis);
    $('.sample-graph-render-text').off('click', '.sample-graph-x-axis-use-distance', graph.switchToDistanceXAxis);
  });

  _.extend(SG.prototype, {
    switchToTimeXAxis: function() {
      this.xAxisType('time'); 
      this.render();
    },

    switchToDistanceXAxis: function() {
      this.xAxisType('distance'); 
      this.render();
    },

    disableDragBehavior: function() {
      this.unbindFrom(this, 'mousedown', this.beginDragSelect);
      $('.sg-zooming-tip').hide();
    },
    enableDragBehavior: function() {
      this.bindTo(this, 'mousedown', this.beginDragSelect);
      $('.sg-zooming-tip').show();
    },
    setDragBehaviorToZoomIn: function(e) {
      if(!e || !$(e.target).hasClass("selected")) {
        this.segmentselectedBehavior = 'zoom_in';
        $('.sg-on-drag-zoom-in').addClass('selected');
        $('.sg-on-drag-select-segment').removeClass('selected');
        if(this._currentDragBehaviorFn)
          this.unbindFrom(this, 'segmentselected', this._currentDragBehaviorFn);
        this._currentDragBehaviorFn = this.zoomToDataSlice;
        this.bindTo(this, 'segmentselected', this._currentDragBehaviorFn);
      }
    },

    identifySegment: function(dataSlice) {
      this.unidentifySegment();
      var plotLeft = this.$canvas.offset().left + this.plotMargin().left,
          plotRight = plotLeft + this.plotWidth,
          firstPt = dataSlice.points(0),
          lastPt = dataSlice.lastPoint(),
          offset = this.$canvas.offset(),
          left = offset.left + Math.round(this.plotToPixel(firstPt[this.xAxisType()])),
          width = offset.left + Math.round(this.plotToPixel(lastPt[this.xAxisType()])) - left;
      // totally out of bounds?
      if(left > plotRight || (left + width) < plotLeft)
        return;
      // partially out of bounds?
      if(left < plotLeft) 
        left = plotLeft;
      if(left + width > plotRight)
        width = plotRight - left;

      this._identifiedSegment = dataSlice;
      this.$identifyOverlay = $('<div></div>')
        .css({
          position: 'absolute',
          zIndex: this.zIndex(),
          background: '#0000ff',
          filter: 'alpha(opacity=30)',
          opacity: 0.3
        })
        .height(this.plotHeight).width(width)
        .offset({top: this.$canvas.offset().top + this.plotMargin().top, left: left})
        .prependTo('body');
    },

    unidentifySegment: function() {
      if(this.$identifyOverlay) {
        this.$identifyOverlay.remove();
        delete this.$identifyOverlay;
        delete this._identifiedSegment;
      }
    },

    enableMouseInteractions: function() {
      this._mouseInteractionsDisabled = false;
    },

    disableMouseInteractions: function() {
      this._mouseInteractionsDisabled = true;
    },
    
    unbindMouseInteractions: function() {
      if(!this._mouseInteractionsBound) return;
      this._mouseInteractionsBound = false;
      this.unbindFrom(this, 'mousemove', this.highlightPointUnderMouse);
      this.unbindFrom(this, 'mouseout', this.onMouseOut);
      this.unbindFrom(this, 'mousedown', this.beginDragSelect);
    },

    bindMouseInteractions: function() {
      if(this._mouseInteractionsBound) return;
      if(SG.isModuleLoaded('playback') && (this.isPlaying() || this.isPaused())) return;
      this._mouseInteractionsBound = true;
      this.bindTo(this, 'mousemove', this.highlightPointUnderMouse);
      this.bindTo(this, 'mouseout', this.onMouseOut);
      this.bindTo(this, 'mousedown', this.beginDragSelect);
    },

    // takes page coords
    inPlotBounds: function(x, y) {
      var graphOffset = this.$canvas.offset(),
        plotMargin = this.plotMargin(),
        plotOffset = {top: graphOffset.top + plotMargin.top, left: graphOffset.left + plotMargin.left};
      return x > plotOffset.left && x < plotOffset.left + this.plotWidth && y > plotOffset.top && y < plotOffset.top + this.plotHeight;
    },

    onMouseOut: function() {
      this.defaultMouseOutCleanup();
    },

    // Attach a mousemove handler on window that only highlights points if the mouse is over the plot area.
    //
    // Adding it to window instead of the canvas element because labels and other things might appear over the canvas 
    // and get in the way. Also, this makes it easy to remove the hover element when the mouse leaves the plot area.
    setupMouseMove: function () {
      var that = this;
      this.bindTo(this.$body, 'mousemove', _.throttle(function (e) { 
        if (that._mouseInteractionsDisabled) return;
        var graphOffset = that.$canvas.offset(),
        plotMargin = that.plotMargin(),
        plotOffset = {top: graphOffset.top + plotMargin.top, left: graphOffset.left + plotMargin.left};
        // if mouse is in plot bounds, highlight position.  otherwise, hide highlight stuff if its showing
        if(that.inPlotBounds(e.pageX, e.pageY) && !that.inBoundsOfControl(e.pageX, e.pageY)) {
          var canvasCoords = that.eventToCanvasCoords(e, graphOffset);
          if(!that.mouseCurrentlyOver) {
            that.trigger('mouseover', e);
            that.mouseCurrentlyOver = true;
            that.mouseStillVerticallyOver = true;
          }
          that.trigger('mousemove', canvasCoords.x, canvasCoords.y, e);
        } else {
          if(that.mouseCurrentlyOver) {
            that.mouseCurrentlyOver = false;
            that.trigger('mouseout', e);
          }
          // we have a more specific event, verticalmouseout, that
          // fires when the mouse y position gets off the graph,
          // but we ignore x and pretend the graph extends forever
          // horizontally. this allows easily drag-selecting all the
          // way to the first or last point
          if(that.mouseStillVerticallyOver && !(e.pageY > plotOffset.top && e.pageY < plotOffset.top + that.plotHeight)) {
            that.mouseStillVerticallyOver = false;
            that.trigger('verticalmouseout', e);
          }
        }
      }, 20));
    },

    highlightPointUnderMouse: function(x) {
      // default, just highlight the point we're over
      if(this.dataToRender().length == 0) return;
      var pointsAroundX = this.canvasXToDataI(x);
      this.highlightPoint(pointsAroundX);
      this.trigger('highlight_at_position', pointsAroundX);
    },

    highlightPoint: function(pointsAroundX) {
      var point = pointsAroundX.estimatedPoint;
      rwgps.Events.trigger('sg:highlightPoint', pointsAroundX)
      this.highlightPointAtX(point, pointsAroundX.x);
      this.showPointDetails(point, pointsAroundX.x);
    },

    highlightPointByIndex: function(i, showPointDetails, segmentSelectorIndex) {
      if (this.dataToRender() && i > this.dataToRender().length) {
        return
      }
      if(segmentSelectorIndex) {
        i += this.segmentSelector.dataSlice.i - this.zoomedSlice().i;
      }
      var pt = this.dataToRender()[i],
          x = this.plotToPixel(pt[this.xAxisType()]);
      this.highlightPointAtX(pt, x);
      if(showPointDetails) {
        this.showPointDetails(pt, x);
      }
    },

    // given a canvas x coord, will highlight the point at that position
    highlightPointAtX: function(nearestPoint, x) {
      // they are always created together so only need to check for one of them
      if(!this.$hoverElVertical) {
        this.$hoverElVertical = $('<div></div>')
          .addClass('sg-elem')
          .addClass('sg-hover')
          .addClass('sg-hover-vertical-line')
          .css({zIndex: this.zIndex()})
          .height(this.plotHeight)
          .prependTo(this.$canvas.parent());
        this.$hoverElHorizontal = $('<div></div>')
          .addClass('sg-elem')
          .addClass('sg-hover')
          .addClass('sg-hover-horizontal-line')
          .css({zIndex: this.zIndex()})
          .width(this.plotWidth)
          .prependTo(this.$canvas.parent());
        this.$hoverXLabel = $('<span></span>')
          .addClass('sg-elem')
          .addClass('sg-hover')
          .addClass('sg-hover-x-label')
          .css({zIndex: this.zIndex()})
          .prependTo(this.$canvas.parent());
        this.trigger('hoverEl:created');
      }
      this._pointHighlighted = {
        point: nearestPoint,
        x: x
      }
      this.repositionPointHighlight();
      return nearestPoint;
    },

    repositionPointHighlight: function() {
      var metric = this.primaryMetric();
      if(!this._pointHighlighted || !this.$hoverElVertical || !metric) return;
      var y = this.plotToPixel(null, this._pointHighlighted.point[metric.key()], metric.key());
      var offset = this.$canvas.offset();
      this.$hoverElVertical.offset({top: offset.top + this.plotMargin().top, left: offset.left + this._pointHighlighted.x});
      this.$hoverElHorizontal.offset({top: offset.top + y, left: offset.left + this.plotMargin().left});
      var xAxisType = this.xAxisType();
      var label = this.formatNumber(this.metrics(xAxisType).convert(this._pointHighlighted.point[xAxisType]),
                                    xAxisType,
                                    true);
      this.$hoverXLabel.html(label);
      this.$hoverXLabel
        .offset({top: offset.top + this.plotMargin().top + this.plotHeight, left: offset.left + this._pointHighlighted.x - this.$hoverXLabel.outerWidth()/2})

    },

    // presumably the mouse has just gone down, and its time to enter
    // drag-select mode. we'll visually show the user what they are
    // selecting, and once the mouse comes back up we'll trigger an event
    beginDragSelect: function(e) {
      if (this._mouseInteractionsDisabled) return;
      if(this.dataToRender().length == 0) return;
      // this only happens when you drag out of a window then mouseup
      // before coming back and screw up our state... if that happens
      // just cancel it 
      if(this.dragging) {
        this.endDragSelect();
        return;
      }
      // cancel out any text selections
      document.body.focus();
      // prevent text selection in IE
      document.onselectstart = function () { return false; };

      // prevent stuff on the page from getting selected during drag
      e.preventDefault();
      // alright we're dragging, lets keep track of our state in here
      this.dragging = {
        $overlay: null,
        startX: this.eventToCanvasCoords(e).x
      }
      // create the cool selection overlay
      this.dragging.$overlay = $('<div class="sg-segment-selector-control"></div>')
        .css({
          zIndex: this.zIndex(),
          background: 'black',
          filter: 'alpha(opacity=50)',
          opacity: 0.5,
          position: 'absolute'
        })
        .offset({top: this.$canvas.offset().top + this.plotMargin().top})
        .height(this.plotHeight)
        .prependTo(this.$canvas.parent());

      // the default interaction of highlighting points on mousemove
      // is cool so we arent going to remove it, just bind some extra
      // behavior for visualizing/cancelling/completing the select
      this.bindTo(this, 'mousemove', this.adjustSelection);
      this.bindTo(this, 'mouseout', this.dragSelectMouseOut);
      this.bindTo(this, 'verticalmouseout', this.cancelDragSelect);
      // have to bind it to window to catch mouseup events outside browser viewport 
      this.bindTo($(window), 'mouseup', this.completeDragSelect);
      this.trigger('dragselect:begin');
    },

    // if the mouse is off to the left or right, snap the selection there
    dragSelectMouseOut: function(e) {
      var coords = this.eventToCanvasCoords(e),
        leftSide = this.plotMargin().left,
        rightSide = leftSide + this.plotWidth;
      if(coords.x <= leftSide) 
        this.adjustSelection(leftSide);
      else {
        // if i dont add one here it only selects until one pixel
        // before the very end
        this.adjustSelection(rightSide+1);
      }
    },

    adjustSelection: function(x) {
      // just adjust the dragSelectOverlay - the width is how far away from where we started, and the position is based on whether we're to the left or right
      var displacement = x - this.dragging.startX, 
        left;
      if(displacement < 0) {
        // gone to the left of start position, so left side of overlay
        // is where the mouse is. need to add a pixel to make the
        // filled area cover the full range selected.
        left = this.canvasToPageCoords(x) + 1; 
      } else {
        // gone to the right, so leave the left side of the overlay at the start of the drag
        left = this.canvasToPageCoords(this.dragging.startX);
      }
      // width is just |displacement| in our 1 dimensional world
      this.dragging.$overlay
        .width(Math.abs(displacement))
        .offset({top: this.$canvas.offset().top + this.plotMargin().top, left: left});
    },
    
    // whether cancelled or completed, when dragSelect is done with we
    // need to unbind its events and clean up its associated data/dom element
    endDragSelect: function() {
      this.dragging.$overlay.remove();
      delete this.dragging;
      // undo our text selection prevention for IE
      document.onselectstart = null;
      this.unbindFrom(this, 'mousemove', this.adjustSelection);
      this.unbindFrom(this, 'verticalmouseout', this.cancelDragSelect);
      this.unbindFrom(this, 'mouseout', this.dragSelectMouseOut);
      this.unbindFrom($(window), 'mouseup', this.completeDragSelect);
      this.trigger('dragselect:end');
    },

    cancelDragSelect: function() {
      this.endDragSelect();
    },

    // moused up in the plot area after mousing down... this could
    // just be a click though, so check for that before we declare a
    // segment has been selected
    completeDragSelect: function(e) {
      var endPosition = this.eventToCanvasCoords(e),
        startX = this.dragging.startX,
        displacement = endPosition.x - startX;
      this.endDragSelect();
      // with a 1 pixel epsilon, call this a pointselected event instead of a segmentselected
      if(Math.abs(displacement) <= 1) {
        var pointsAround = this.canvasXToDataI(startX);
        this.trigger('pointselected', pointsAround);
      } else {
        // otherwise, we've got ourselves a segmentselected 
        var firstX = (displacement < 0) ? endPosition.x : startX,
          firstI = this.canvasXToDataI(firstX).closestI,
          lastI = this.canvasXToDataI(firstX + Math.abs(displacement)).closestI;
        if(lastI - firstI > 1) {
          var dataSlice = this.dataSlice(firstI, 1+lastI-firstI);
          this.trigger('segmentselected', dataSlice);
        }
      }
    },
    
    defaultMouseOutCleanup: function() {
      // get rid of the hoverline if its there
      if(this.$hoverElHorizontal) { this.$hoverElHorizontal.remove(); delete this.$hoverElHorizontal; }
      if(this.$hoverElVertical) { this.$hoverElVertical.remove(); delete this.$hoverElVertical; }
      if(this.$hoverMetrics) { this.$hoverMetrics.remove(); delete this.$hoverMetrics; }
      if(this.$hoverXLabel) { this.$hoverXLabel.remove(); delete this.$hoverXLabel; }
      delete this._pointHighlighted;
    },

    // render, position, populate the hover box
    // right now we're just handing it the nearest point, but we're
    // going to want to interpolate that shit based on this x, threw
    // it in asana
    showPointDetails: function(point, x) {
      if(!this.$hoverMetrics) {
        this.$hoverMetrics = $('<div></div>')
          .addClass('sg-elem')
          .addClass('sg-hover-details')
          .css({zIndex: this.zIndex()})
          .prependTo(this.$canvas.parent());
        _.each(this.metricsKeysY(), function(metric) {
          if (metric === 'grade') return; // displayed in ele
          if (metric === 'surfaces' && !this.showSurface()) return;
          this.$hoverMetrics.append('<span class="sg-metric sg-'+metric+'"></span><br />');
        }, this);
      }
      // lets remember the width and let it get wider, but not
      // narrower... too jarring to bounce back and forth in width and
      // this is the laziest way to calculate max width
      var minWidth = this.$hoverMetrics.width();

      // populate with metrics
      this.$hoverMetrics.find('.metric').hide();
      var metricUnits = rwgps.LabelMaker.metric;
      _.each(this.metricsY(), function(metric) {
        var key = metric.key();
        var value = point[this.metricVariationInUse(key)];
        if(_.isNumber(value)) {
          var html;
          switch(key) {
          case 'ele':
            html = [Math.round(rwgps.Convert.mToShort(value)), metricUnits ? ' ' + T.t('sample_graph.m') : ' ' + T.t('sample_graph.ft')];
            if(point.grade) html.push(' (', point.grade.toFixed(1), T.t('sample_graph.percent'), ')');
            break;
          case 'grade':
            return; // displayed alongside ele already
          case 'speed':
            html = [metric.convert(value).toFixed(1), metricUnits ? ' ' + T.t('sample_graph.kph') : ' ' + T.t('sample_graph.mph')];
            break;
          default:
            html = [Math.round(metric.convert(value)), ' ', T.t('sample_graph.' + SG.unitsFor(key))];
            break;
          }
        } else if (this.showSurface()) {
          // since 'surfaces' is not included in metricsY, do it separately
          html = [rwgps.surfaces.surfaceGroups[point.surface], ' ', T.t('sample_graph.surface')];
        } else { html = [] }
        this.$hoverMetrics.find('.sg-metric.sg-' + key).html(html.join('')).show();
        if (key === 'surfaces' && this.$hoverMetrics.find('.sg-surfaces').width() > this.$hoverMetrics.width()) {
          // if the surface changes, it's possible for the new label to grow.
          // if that's the case, let's make some more room!
          this.$hoverMetrics.width(this.$hoverMetrics.find('.sg-surfaces').width());
        }
      }, this);
      if(this.$hoverMetrics.width() < minWidth) this.$hoverMetrics.width(minWidth);
      this._pointHighlighted = {
        point: point,
        x: x
      }
      this.repositionPointDetails();
    },

    bindEvents: function () {
      $('.sample-graph-render-text').on('click', '.sg-on-drag-zoom-in', this.setDragBehaviorToZoomIn);
      $('.sample-graph-render-text').on('click', '.sample-graph-x-axis-use-time', this.switchToTimeXAxis);
      $('.sample-graph-render-text').on('click', '.sample-graph-x-axis-use-distance', this.switchToDistanceXAxis);
    },

    redrawOverlays: function() {
      // if the graph has just been hidden, get rid of all our
      // floating elements and dont do anything else
      if(this.$canvas.is(':hidden')) {
        $('.sg-elem').remove();
        // unbind global listeners
        this.unbindMouseInteractions();
        return;
      } else {
        // rebind if necessary
        this.bindMouseInteractions();
      }
      // if x-axis changes, need to figure out what x offset is for new
      // position of highlighted point.  also repositions point details
      // and point highlight (crosshairs).
      if(this._pointHighlighted) {
        var point = this._pointHighlighted.point;
        this.defaultMouseOutCleanup();
        this._pointHighlighted = {
          point: point,
          x: this.plotToPixel(point[this.xAxisType()])
        };
        this.highlightPointAtX(this._pointHighlighted.point, this._pointHighlighted.x);
        this.showPointDetails(this._pointHighlighted.point, this._pointHighlighted.x);
      }
      if(this.$zoomingTip) {
        this.$zoomingTip.remove(); 
        delete this.$zoomingTip;
      }
      this.updateZoomingTip();
      
      if(this._identifiedSegment) this.identifySegment(this._identifiedSegment);
    },

    updateZoomingTip: function() {
      // create node if doesn't exist
      if(!this.$zoomingTip) {
        this.$zoomingTip = $('<span></span>')
          .addClass(this.uniqueClass)
          .addClass('sg-elem')
          .addClass('sg-zooming-tip')
          .css({zIndex: this.zIndex()})
          .prependTo(this.$canvas.parent());
      }
      // populate with appropriate tip
      if(this.zoomedIn()) {
        if(this.options.extendedSelectionOptions) {
          this.$zoomingTip.html(['<a href="javascript:;" class="sg-select-segment sg-bold">',
                                 T.t('sample_graph.select_segment'),
                                 '</a> ',
                                 T.t('sample_graph.click_to_zoom_out')].join(''));
        } else {
          this.$zoomingTip.html(T.t('sample_graph.click_to_zoom_out'));
        }
      } else {
        if(this.options.extendedSelectionOptions) {
          this.$zoomingTip.html([T.t('sample_graph.on_drag'),
                                 ' <a href="javascript:;" class="sg-on-drag-zoom-in">',
                                 T.t('sample_graph.zoom_in'),
                                 '</a> <a href="javascript:;" class="sg-on-drag-select-segment">',
                                 T.t('sample_graph.select_segment'),
                                 '</a>'
                                ].join(''));
          $(this.segmentselectedBehavior == 'zoom_in' ? '.sg-on-drag-zoom-in' : '.sg-on-drag-select-segment').addClass("selected");
        } else {
          this.$zoomingTip.html(T.t('sample_graph.drag_to_zoom_in'));
        }
      }
      // position it in the lower right
      var offset = this.$canvas.offset();
      var rightMargin = 10 + this.plotMargin().right, bottomMargin = 8;
      this.$zoomingTip.offset({left: offset.left + this.$canvas.width() - this.$zoomingTip.width() - rightMargin,
                               top: offset.top + this.$canvas.height() - this.$zoomingTip.height() - bottomMargin});
    },

    // we need to get x from the point if the x-axis changes
    repositionPointDetails: function() {
      if(!this._pointHighlighted || !this.$hoverMetrics) return;
      var height = 75;
      var offset = this.$canvas.offset();
      var topMargin = this.plotHeight > height ? (this.plotHeight - height) / 2 : 0;
      var leftMargin = 15;
      var buffer = 20;
      if(this.$hoverMetrics.width() + this._pointHighlighted.x + leftMargin + buffer > this.$canvas.width()) {
        // show on left
        this.$hoverMetrics.offset({top: offset.top + this.plotMargin().top + topMargin,
                                   left: offset.left + this._pointHighlighted.x - leftMargin - this.$hoverMetrics.outerWidth()});
      } else { 
        this.$hoverMetrics.offset({top: offset.top + this.plotMargin().top + topMargin,
                                   left: offset.left + this._pointHighlighted.x + leftMargin});
      }
    },

    // mousemove calls this repeatedly and already has graphOffset handy, so letting it get passed in optionally
    eventToCanvasCoords: function(e, graphOffset) {
      if(!graphOffset) graphOffset = this.$canvas.offset();
      var canvasX = e.pageX - graphOffset.left,
        canvasY = e.pageY - graphOffset.top;
      return {x: canvasX, y: canvasY};
    },
    
    // works like plotToPixel in that x and y are optional
    canvasToPageCoords: function(x, y) {
      var graphOffset = this.$canvas.offset(), pageX, pageY;
      if(x || x==0) pageX = x + graphOffset.left;
      if(y || y==0) pageY = y + graphOffset.top;      
      if(!x && x!=0) return pageY;
      if(!y && y!=0) return pageX;
      return {x: pageX, y: pageY};
    }
  });
})(SampleGraph, window);



// WEBPACK FOOTER //
// ./public/javascripts/sample_graph/sample_graph.interaction.js